import { removeEmpty } from '@utils/remove-empty.helper';
import { MenuUsageEvent } from '@utils/gtm-tracking/model/MenuUsageEvent';

export const mapToMenuLevels = (url: string, productId?: string, productName?: string): MenuUsageEvent => {
    const parsedURL = new URL(url);
    const { pathname = '' } = parsedURL;
    const slashFreePath = pathname.startsWith('/') ? pathname.substring(1) : pathname;
    const [first, second, third] = slashFreePath.split('/');
    return removeEmpty({
        first_level: first,
        second_level: second,
        third_level: third,
        menu_item_id: productId,
        menu_item_name: productName
    });
};
